import script from "./LiveSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSchedule.vue?vue&type=script&setup=true&lang=js"

import "./LiveSchedule.vue?vue&type=style&index=0&id=1d54e731&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d54e731"]])

export default __exports__